<template>
  <el-form :model="formData" label-width="10px" style="height: 40px">
    <el-row>
      <el-form-item label="" prop="star">
        <el-select v-model="formData.wujianId" @change="getBuildingNameList" filterable :placeholder="$t('makeSchedule.visualizationPage.wujianId')"
                   class="toolbar_item" style="width: 200px" clearable>
          <el-option v-for="dict in wujianNameList" :key="dict.value" :label="dict.label"
                     :value="dict.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formData.building" :placeholder="$t('makeSchedule.visualizationPage.floor')" class="toolbar_item" style="width: 100px" clearable>
          <el-option v-for="dict in buildingNameList" :key="dict.floor" :label="dict.floor"
                     :value="dict.floor"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="wujianVisualizationBool" @click="getWujianVisualization">查询
        </el-button>
      </el-form-item>

      <el-form-item>
        <i class="dotClass" style="background: #E9ECEF"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.noZk') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #a0d7ff"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.zking') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #37e3dc;"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.zkEnd') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #1436e8bf"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.sczsEnd') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #FFD43B;"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.jgEnd') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #ea29e6"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.tzEnd') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #94D82D"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.zzEnd') }}</span>
      </el-form-item>
      <el-form-item>
        <i class="dotClass" style="background: #12B886"></i>
        <span style="margin-left: 10px">{{ $t('makeSchedule.visualizationPage.chEnd') }}</span>
      </el-form-item>
    </el-row>
  </el-form>

  <el-table style="overflow: auto;padding: 0" :data="wujianVisualization" border :height="tableHeight"
            :header-cell-style="{textAlign: 'center'}"
            :cell-style="{ textAlign: 'center'}"
            size="small">
    <el-table-column prop="floor" :label="$t('makeSchedule.visualizationPage.louMian')" width="60" fixed/>
    <el-table-column v-for="facade in facadeList" :min-width="flexColumnWidth(facade.facade_id,facade.facade_id)"
                     :prop="facade.facade_id" :key="facade.facade_id" :label="facade.facade_id">
      <template v-slot="scope">
        <div style="display: flex;flex-direction: row">
          <div style="background-color: #D0EBFF;margin-left: 2px;width: 4px;height: 100%;" :style="unit.color"
               v-for="(unit,index) in scope.row[facade.facade_id]" :key="index">
            <el-tooltip class="box-item" effect="dark" :content="unit.unit_no" placement="top">
              <span>&nbsp;</span>
            </el-tooltip>
          </div>
          <!--            <div v-if="scope.row[facade.facade_id].length > 0" style="">-->
          <!--              &nbsp;{{scope.row[facade.facade_id].length}}-->
          <!--            </div>-->
        </div>
      </template>
    </el-table-column>
  </el-table>

</template>

<script>
export default {
  name: "MfgVisualization",
  components:{},
  props:{

  },
  data() {
    return {
      formData: {
        wujianId:'',
        building:'',
      },
      wujianNameList:[],
      buildingNameList:[],
      wujianVisualization:[],
      newUnitList:[],
      facadeList:[],
      wujianVisualizationBool: false,
      tableHeight: window.innerHeight - 200,
    }
  },methods: {
    //获取物件名称
    getAllWujianName() {
      this.$axios.post('mfg/wujianPlan/getWujianName',).then(response => {
        let res = response.data
        this.wujianNameList = res.data

      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    //获取所有楼层
    getBuildingNameList() {
      if (!this.formData.wujianId) {
        return this.$message.error("物件不能为空");
      }

      this.$axios.post('mfg/visualization/getBuildingNameList', this.formData.wujianId).then(response => {
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }

        this.buildingNameList = res.data
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    getWujianVisualization() {
      if (!this.formData.wujianId) {
        return this.$message.error("物件不能为空");
      }

      if (!this.formData.building) {
        this.getWujianVisualizationAll();
        return
      }

      this.wujianVisualizationBool = true;
      this.$axios.post('mfg/visualization/getWujianVisualization', this.formData).then(response => {
        this.wujianVisualizationBool = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }

        this.wujianVisualization = res.data.newUnitList;
        console.log("wujianVisualization=",this.wujianVisualization)
        this.facadeList = res.data.facadeList;
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    getWujianVisualizationAll() {
      this.wujianVisualizationBool = true;
      let params = {wujianId: this.formData.wujianId, buildingNameList: this.buildingNameList}
      this.$axios.post('mfg/visualization/getWujianVisualizationAll', params).then(response => {
        this.wujianVisualizationBool = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }

        this.wujianVisualization = res.data.newUnitList;
        console.log("wujianVisualization=",this.wujianVisualization)
        this.facadeList = res.data.facadeList;
        console.log("facadeList=",this.facadeList)
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    flexColumnWidth (label, prop) {
      // 1.获取该列的所有数据
      const arr = this.wujianVisualization.map(x => x[prop])
      arr.push(label) // 把每列的表头也加进去算
     // console.log(arr)
      let maxCnt = 0 ;
      for (let cnt of arr) {
        if (maxCnt < cnt.length) {
          maxCnt = cnt.length;
        }
      }
      return maxCnt * 6 + 24;
    },
  },created() {
    this.getAllWujianName();
  },mounted() {
    // window.onresize:浏览器尺寸变化响应事件
    window.onresize = () => {
      return (() => {
        // window.innerHeight:浏览器的可用高度
        window.screenHeight = window.innerHeight;
        this.tableHeight = window.screenHeight - 200;
      })();
    };
  }
}

</script>
<style scoped>
.dotClass {
  height: 15px;
  width: 15px;
  margin-left: 10px;
}
div /deep/ .el-table tbody tr:hover>td {
  background: #ffffff!important
}

.table :deep(.el-table__cell) {
  padding: 0 0;
  min-width: 0;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
  z-index: 1;
}

.table :deep(.el-table-fixed-column--left){
  z-index: 2;
}

</style>